import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import {
  PATH_MATERIAL_DEFAULT,
  PATH_MATERIALS,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import { useIdParam } from '../../utils/use-id-param.util';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { useBuildPath } from '../../hooks/useBuildPath.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { MaterialTabs } from './Tabs';
import { useFindOneMaterialQuery } from './hooks/useFindOneMaterialQuery.hook';

export const MaterialPage = () => {
  const { setPage } = useNavigationContext();
  const id = useIdParam();

  const path = useBuildPath(PATH_MATERIAL_DEFAULT, { id });

  const { data, isSuccess } = useFindOneMaterialQuery(id);

  useEffect(() => {
    setPage(Page.Materials);
  }, [setPage]);

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle('Fiche Matériel', data?.findOneMaterial.code)}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_MATERIALS,
            label: 'matériels',
            key: 'materials',
          },
          {
            to: path,
            label: 'fiche',
            key: 'material',
          },
        ]}
      />
    </>
  );

  const titleContent = <PageTitle title="Fiche Matériel" />;

  if (isSuccess) {
    const material = data.findOneMaterial;

    return (
      <>
        {beforeTitleContent}
        <PageTitle code={material.code} title={material.label} />
        <MaterialTabs material={material} />
      </>
    );
  }

  return (
    <>
      <Loading />
      {beforeTitleContent}
      {titleContent}
    </>
  );
};
